import request from '@/utils/request';

export function getProcurementList(form) {
    let state = form.state == 'all' ? null : form.state;
    let cgType = form.cgType == 'all' ? null : form.cgType;
    let wlxx = form.wlxx == 'all' ? null : form.wlxx;
    let params = {
        state: state,
        cgType: cgType,
        wlxx: wlxx,
        procurementNo: form.procurementNo,
        supplierName: form.supplierName,
        localSKU: form.localSKU,
        cpName: form.cpName,
        orderNo: form.orderNo,
        ydNo: form.ydNo
    };
    return request({
        url: '/procurement/list',
        method: 'get',
        params: params
    })
}

export function createOrder(id) {
    return request({
        url:'/procurement/create/',
        method: 'put',
        params:{id:id}
    })
}

export function uploadImg(data){
    return request({
        url:'/procurement/uploadImg',
        method:'post',
        data:data
    })
}

export function getDzMapList(params) {
    return request({
        url:'/procurement/dzMap/list',
        method:'get',
        params:params
    })
}

export function removeImgs(data) {
    return request({
        url:'/procurement/dzMap/delete',
        method:'delete',
        data:data
    })
}
